import React, { useEffect, useState } from 'react';
import './LoadingScreen.css';

const LoadingScreen = () => {
  const [progress, setProgress] = useState(0);

useEffect(() => {
  const timer = setInterval(() => {
    setProgress(prev => {
      if (prev >= 100) return 100;
      return Math.min(prev + Math.random() * 5, 100); // smaller increments
    });
  }, 300); // smaller interval for smoother fill

  return () => clearInterval(timer);
}, []);


  return (
    <div className="loading-screen">
      <div className="loading-container">
        <div className="logo-animation">
          <img src="/logo.png" alt="OZIA" className="ozia-loading-logo"/>
          <div className="logo-text"> OZIA_ai</div>
          <div className="logo-subtitle"><br></br>Loading your AI coding companion...</div>
        </div>
        
        <div className="progress-bar">
          <div className="progress-fill" style={{ width: `${progress}%` }}></div>
        </div>
        
        <div className="loading-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>

        <div className="loading-features">
          <div className="feature">
            <span className="feature-icon">🔐</span>
            <span>Initializing Security</span>
          </div>
          <div className="feature">
            <span className="feature-icon">🤖</span>
            <span>Loading AI Engine</span>
          </div>
          <div className="feature">
            <span className="feature-icon">🌐</span>
            <span>Connecting to Services</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;